import React from "react";
import { Container, Row } from "reactstrap";
import PropTypes from "prop-types";

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          <Row>
            <nav className="footer-nav">
              <ul>
                <li>
                  <a href="https://www.npmjs.com/package/bioinformatics-hub" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-npm" /> npm
                  </a>
                </li>
                <li>
                  <a href="https://github.com/FanPu1/bioinformatics-hub" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-github" /> GitHub
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/FanPu1/bioinformatics-hub/blob/master/LICENSE"  target="_blank" rel="noopener noreferrer">
                    Mit Licenses
                  </a>
                </li>
              </ul>
            </nav>
            <div className="credits ml-auto">
              <div className="copyright">
                &copy; {1900 + new Date().getYear()} by Bioinformatics-hub
              </div>
            </div>
          </Row>
          <hr />
          <Row>
            <p className="footer-nav ">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
            </p>
          </Row>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
